// extracted by mini-css-extract-plugin
export var background = "map-module-module--background--abae5";
export var carouselContainer = "map-module-module--carouselContainer--02a87";
export var content = "map-module-module--content--9602d";
export var filtersColumn = "map-module-module--filtersColumn--1f4dd";
export var header = "map-module-module--header--3d756";
export var imagesContainer = "map-module-module--imagesContainer--096bf";
export var mainImage = "map-module-module--mainImage--2fee4";
export var text = "map-module-module--text--85cb3";
export var title = "map-module-module--title--d6953";